import { Component, Inject, inject, LOCALE_ID, signal, ViewChild } from '@angular/core';
import { TitleComponent } from '../../../shared/components/title-component/title-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SuiviService } from '../../service/suivi-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { Assurance, Site } from '../../../shared/model';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { HomeService } from '../../../components/services/home-service';
import { DatabaseConnection } from '../../../shared/services/database-connection';
import { AuthService } from '../../../auth/services/auth-service';
import { DateMaskDirective } from '../../../shared/Directive/DateMask';
import { combineLatest, Subscription } from 'rxjs';
import { ExportComponent } from '../../../shared/components/export-component/export-component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-validation-suivi-details-component',
  imports: [
    TitleComponent,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatProgressSpinner,
    SearchBarComponent,
    MatIcon,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule
  ],
  templateUrl: './validation-suivi-details-component.html',
  styleUrl: './validation-suivi-details-component.css',
})
export class ValidationSuiviDetailsComponent {
  displayedColumns: string[] = ['assure', 'categorie', 'puissance_en', 'dta', 'attestation', 'effet', 'fin', 'compagnie', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  loading = signal(false)
  rapportData : Assurance[] = []
  bureau : Site = new Site()
  title = signal('Validtion de suivi')

  dateForm = new FormGroup({
    date_debut : new FormControl(new Date(), [Validators.required]),
    date_fin : new FormControl(new Date(), [Validators.required])
  })

  authService = inject(AuthService)
  site_id : string = ""

  state = signal('')
  groupe = ''
  routeSub !: Subscription

  readonly dialog = inject(MatDialog);

  constructor(
    private suiviService : SuiviService,
    private sweetService : SweetAlertService,
    private toastr : ToastrService,
    private route : ActivatedRoute,
    private homeService : HomeService,
    private databaseCon : DatabaseConnection,
    private activatedRoute : ActivatedRoute,
   @Inject(LOCALE_ID) private locale : string,
  ){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.route.params.subscribe((res) => {

    })

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.routeSub = combineLatest([this.activatedRoute.paramMap, this.activatedRoute.queryParamMap])
    .subscribe(([params, queryParams]) => {
      this.state.update(val => params.get('slug')??'');
      //this.groupe = queryParams.get('groupe')??''
      this.site_id = params.get('id')??''

      if(this.state()=='reception'){
        this.loadRapportsReception(this.site_id)
      }else if(this.state()=='validation'){
        this.loadRapportsValidation(this.site_id)
      }
    })
  }

  applyFilter(event : string){
    this.selection.clear();
    this.rapportData.splice(0, this.rapportData.length)
    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadRapportsValidation(bureau_id : string){
    this.loading.update(val => true)
    this.suiviService.listValidationRapportBureaux(bureau_id).subscribe({
      next : (res) =>{
        this.loading.update(val => false)
        console.log(res);
        this.dataSource.data = res.assurance.slice()
        this.bureau = res.bureau
        this.title.update(val => 'Validation du suivi : ' + res.bureau.name)
      },
      error : (err) =>{
        this.loading.update(val => false)
      }
    })
  }

  loadRapportsReception(bureau_id : string){
    this.loading.update(val => true)
    this.suiviService.listReceptionRapportBureaux(bureau_id).subscribe({
      next : (res) =>{
        this.loading.update(val => false)
        console.log(res);
        this.dataSource.data = res.assurance.slice()
        this.bureau = res.bureau
        this.title.update(val => 'Reception du suivi : ' + res.bureau.name+" groupe de "+res.bureau.groupe_name)
      },
      error : (err) =>{
        this.loading.update(val => false)
      }
    })
  }

selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.rapportData = []
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
    this.rapportData = this.dataSource.filteredData.slice()
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  selectAssurance(row : Assurance){
    if(this.rapportData.findIndex(item => item.id == row.id) == -1 && this.selection.isSelected(row)){
      this.rapportData.push(row)
    }else{
      this.rapportData.splice(this.rapportData.findIndex(item => item.id == row.id), 1)
    }
  }

  onValidate(){
    this.sweetService.confirm('Voulez-vous vraiment valider ?').then((res) =>{
      if(res.isConfirmed){
        this.suiviService.validation(this.rapportData).subscribe({
          next : (res) =>{
            this.loadRapportsValidation(this.bureau.id)
            this.selection.clear()
          },
          error : (err) =>{
            this.toastr.error("Une erreur est survenue")
          }
        })
      }
    })
  }

  reception(){
    this.sweetService.confirm('Voulez-vous vraiment valider ?').then((res) =>{
      if(res.isConfirmed){
        this.suiviService.reception(this.rapportData).subscribe({
          next : (res) =>{
            this.loadRapportsReception(this.bureau.id)
            this.selection.clear()
          },
          error : (err) =>{
            this.toastr.error("Une erreur est survenue")
          }
        })
      }
    })
  }

  openExportModal(){
    this.dialog.open(ExportComponent, {
      width: '500px',
      data : 'export-validation-suivi'
    })
  }

  
}
